import stationColors from '@/models/stationColors';

export default {

  buildLabels(range) {
    const numOfHours = range.interval.length('hours');

    let increment = { hours: 168 };   // default (numOfHours < 24)

    if (numOfHours < 24) {
      increment = { hours: 1 };
    }

    if (numOfHours >= 24 && numOfHours < 48) {
      increment = { hours: 3 };
    }

    if (numOfHours >= 48 && numOfHours < 240) {
      increment = { hours: 6 };
    }

    if (numOfHours >= 240 && numOfHours < 336) {
      increment = { hours: 12 };
    }

    if (numOfHours >= 336 && numOfHours < 768) {
      increment = { hours: 84 };
    }

    const labels = [];

    let currentTime = range.start.startOf(('hour'));

    // Beginning with the DateRange starting date, create labels every hour until we reach
    // either the end of the interval or the current time
    do {
      labels.push(currentTime.toJSDate());
      currentTime = currentTime.plus(increment);
    } while (range.interval.contains(currentTime) && currentTime.toJSDate() < new Date());
    return labels;
  },

  buildDatasets(sensorVariable) {
    const stations = sensorVariable.stations.filter(st => st.observations.length);
    const numDays = Math.round(sensorVariable.range.numOfDays);
    let pointRadius = 2;

    if (numDays >= 4) {
      pointRadius = 0;
    }

    if (numDays === 3) {
      pointRadius = 1;
    }

    if (numDays < 3) {
      pointRadius = 2;
    }

    // eslint-disable-next-line
    return stations.map((station) => {
      return {
        backgroundColor: stationColors[station.stationId] || 'rgb(0,0,0)',
        borderColor: stationColors[station.stationId] || 'rgb(0,0,0)',
        label: station.stationId,
        data: station.observations,
        type: 'line',
        pointRadius,
        fill: false,
        borderWidth: 2,
        spanGaps: true,
      };
    });
  },

};



// WEBPACK FOOTER //
// ./src/utils/chart.js